<template>
  <b-modal
    id="add-cost-modal"
    :title="$t('objects.register')"
    size="md"
    centered
    :cancel-title="$t('generals.close')"
    :ok-title="$t('generals.save')"
    @hidden="clearFields"
    @ok.prevent="saveFlatRegister"
  >
    <validation-observer ref="flatValidations">
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$t('general.cost')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('general.cost')"
              rules="required"
            >
              <b-form-input
                v-model="formData.price"
                type="number"
                :placeholder="$t('general.cost')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            :label="$t('contract.issue_date')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('contract.issue_date')"
              rules="required"
            >
              <DatePicker
                v-model="formData.created_at"
                :placeholder="$t('contract.issue_date')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BFormInput, BModal, BFormGroup, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapActions } from 'vuex'
import DatePicker from '@/components/datePicker.vue'

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    DatePicker,
  },
  props: {
    flatId: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        price: null,
        created_at: null,
        flat: null,
      },
      required,
    }
  },
  methods: {
    ...mapActions('flats', ['CREATE_FLAT_REGISTER']),
    async saveFlatRegister() {
      const success = await this.$refs.flatValidations.validate()
      if (!success) return
      this.formData.flat = this.flatId
      try {
        await this.CREATE_FLAT_REGISTER(this.formData)
        this.$_successToast(this.$t('generals.added'))
        this.$bvModal.hide('add-cost-modal')
      } catch (error) {
        this.$_errorToast(this.$t('generals.error'))
      }
    },
    clearFields() {
      this.formData = {
        price: null,
        created_at: null,
        flat: null,
      }
    },
  },
}
</script>

<style>

</style>
